import React from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";
import { ChartWrapper, Placeholder } from "./styles/chart-styles";

const Donut = ({ graphOptions, dataTestId, placeholderHidden }) => {
  const { options, series } = graphOptions;

  return (
    <ChartWrapper className="chart-item" data-test-id={dataTestId}>
      {series.length > 0 ? (
        <Chart
          options={options}
          series={series}
          type="donut"
          data-test-id="donut-chart-test-id"
          width={options.width}
          height={options.height}
        />
      ) : (
        <Placeholder
          data-test-id="donut-chart-placeholder"
          hidden={placeholderHidden}
        >
          no data
        </Placeholder>
      )}
    </ChartWrapper>
  );
};

Donut.propTypes = {
  graphOptions: PropTypes.shape({
    options: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    series: PropTypes.arrayOf(PropTypes.number),
  }).isRequired,
  dataTestId: PropTypes.string,
  placeholderHidden: PropTypes.bool,
};

Donut.defaultProps = {
  dataTestId: PropTypes.isNull,
  placeholderHidden: PropTypes.isNull,
};

export default Donut;
